import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function GeographyFilter({ value = "", onChange, extraOptions = [] }) {
    const [options, setOptions] = useState([]);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        let active = true;
        api.get("/geographies").then(({data}) => { if (active) setOptions(data.map(item => item.name)); })
            .catch(() => { if (active) setFailed(true); });
        return () => { active = false; };
    }, []);
    const choices = [...new Set([...options, ...extraOptions, value].filter(Boolean))].sort((a,b) => a.localeCompare(b));
    return <label className="flex flex-col gap-2 text-sm text-neutral-600">Geography
        <select aria-label="Geography" className="border border-neutral-200 rounded-lg px-3 py-2 bg-white max-w-full" value={value} onChange={event => onChange(event.target.value)}>
            <option value="">All geographies</option>{choices.map(name => <option key={name}>{name}</option>)}
        </select>
        {failed && <span role="alert" className="text-xs">Geography list unavailable. Reload to try again.</span>}
    </label>;
}
